import * as React from "react";

export const IconBuilding = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M14.1663 7.5L15.833 7.5V5.83333H14.1663V7.5ZM14.1663 10.8333H15.833V9.16667L14.1663 9.16667V10.8333ZM14.1663 14.1667H15.833V12.5H14.1663V14.1667ZM0.833008 17.5L0.833008 9.16667L6.66634 5L12.4997 9.16667V17.5H8.33301L8.33301 12.5L4.99967 12.5L4.99967 17.5H0.833008ZM14.1663 17.5V8.33333L8.33301 4.125V2.5L19.1663 2.5L19.1663 17.5L14.1663 17.5Z"
      fill="currentColor"
    />
  </svg>
);
